import { useStore } from "#src/stores/Store.tsx";
import tw from "#src/utils/tw.ts";
import { ReactNode } from "react";

interface Props {
  className?: string;
  onClick?: (e: any) => void;
  children: ReactNode;
}

export default function HeaderNavButton(props: Props) {
  const store = useStore();

  return (
    <button
      className={tw(
        "m-0 h-[50px] w-[30px] cursor-pointer border-none p-0 text-left text-xl leading-[50px] outline-hidden",
        store.isAdminArea || store.user?.isStaff
          ? "text-organization"
          : "text-organization",
        props.className
      )}
      data-test="header-nav"
      onClick={props.onClick}
      type="button"
    >
      {props.children}
    </button>
  );
}
